"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ADD_QUERY_INSIGHT = _interopRequireDefault(require("./graphql/ADD_QUERY_INSIGHT"));

var _INSERT_SEARCH_INFO = _interopRequireDefault(require("./graphql/INSERT_SEARCH_INFO"));

var _reactHooks = require("@apollo/react-hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useInsightSubmit = function useInsightSubmit(query, tracking, shouldExecute) {
  var hsid = tracking.hsid,
      oid = tracking.oid,
      eid = tracking.eid,
      sid = tracking.sid,
      uid = tracking.uid,
      ip_address = tracking.ip_address;

  var _useMutation = (0, _reactHooks.useMutation)(_INSERT_SEARCH_INFO.default, {
    onCompleted: function onCompleted() {
      return console.log('SearchInfo posted to CF.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      insertSearchInfo = _useMutation2[0];

  var _useMutation3 = (0, _reactHooks.useMutation)(_ADD_QUERY_INSIGHT.default, {
    onCompleted: function onCompleted() {
      return console.log('QueryInsight posted to Mongo.');
    }
  }),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      addQueryInsight = _useMutation4[0];

  (0, _react.useEffect)(function () {
    if (shouldExecute) {
      insertSearchInfo({
        variables: {
          visitor: {
            'hsid': Number(hsid),
            'oid': Number(oid),
            'eid': eid,
            'sid': Number(sid),
            'uid': uid,
            'ip_address': ip_address,
            'query': query
          }
        }
      });
      addQueryInsight({
        variables: {
          clickId: Number(hsid),
          query: query
        }
      });
    } // eslint-disable-next-line

  }, [shouldExecute]);
  return;
};

var _default = useInsightSubmit;
exports.default = _default;

//# sourceMappingURL=useInsightSubmit.js.map